module.exports = __webpack_public_path__ + "images/af5dae810d0db08a814546ae189c8fa0-logo_textwhite.png";